import styled from 'styled-components';
import {themecolors} from "../utils/themecolors";
import getRemovalSource from "../utils/removal_source";

const TextContent = styled(({className, content, removalSource, type = "Content"}) => (
    <div className={className} dangerouslySetInnerHTML={{__html: !content ? `${type} ${getRemovalSource(removalSource)}` : content}}/>
))`
  blockquote {
    padding: 6px 12px;
    margin: 12px 0;
    border-left: 4px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : themecolors.lighter_border};
  }

  blockquote p {
    margin: 0;
  }

  p {
    margin-bottom: 6px;
  }

  p:last-of-type {
    margin: 0;
  }
  
  a {
    color: ${({theme}) => theme.color.name === 'dark' ? 'rgb(152, 175, 198)' : '#369'};
  }

  hr {
    margin-top: 12px;
    margin-bottom: 12px;
    border-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : '#e8e8e8'};
  }
  
`;

export default TextContent;
